import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

import Label from '../../../components/label';
import Note from '../../../components/note';
import ActionButton from '../../../components/action-button';
import { postData, putData } from '../../../helper/request-response';
import { onSuccess } from '../../../helper/toaster';
import customerTypePath from './config';

const Action = () => {

    const data = useLocation();

    const refData = useRef(data);

    const history = useHistory();

    const [isDisabledSave, setIsDisabledSave] = useState(true);

    const [isResetable, setIsResetable] = useState(true);
    
    const [titleInfo, setTitleInfo] = useState("");

    const [customerType, setCustomerType] = useState({
        id: 0,
        name: "",
        isActive: 1
    });

    const onReset = e => {

        e.preventDefault();

        setCustomerType(type => ({ 
            ...type,
            name: "",
            isActive: 1
        }));
    }

    const onInputChange = e => {

        const { name, value } = e.target;

        setCustomerType(type => ({ 
            ...type,
            [name]: value
        }));
    };

    const onActiveChange = e => {
        
        setCustomerType(type => ({ 
            ...type,
            isActive: customerType.isActive === 1 ? 0 : 1
        }));
    };

    const onSubmit = (e) => {

        e.preventDefault();

        const postCustomerType = async () => {

            const result = await postData(customerTypePath.baseApi, customerType);

            if (Object.keys(result).length) {

                onSuccess(`Tipe pelanggan ${result.name} berhasil di tambahkan`);

                history.goBack();

            }
        };

        const putCustomerType = async () => {

            const result = await putData(`${customerTypePath.baseApi}/${customerType.id}`, customerType);

            if (Object.keys(result).length) {
                
                onSuccess(`Tipe pelanggan ${result.name} berhasil di tambahkan`);

                history.goBack();

            }
        };

        if (customerType.id === 0 && customerType.name) postCustomerType();
        else putCustomerType();
    }

    useEffect(() => {

        const init = () => {

            const state = refData.current.state;

            if (state) {

                setCustomerType(state);

                setTitleInfo(`Detail: ${state.name}`);

                setIsResetable(false);

            } else {

                setTitleInfo("Tambah Tipe Baru");
                
            }
        }

        init();

    }, []);

    useEffect(() => {

        if (customerType.name) setIsDisabledSave(false);

    }, [customerType.name]);

    return(
        <React.Fragment>
            <div className="card-header">
                <h3 className="h6 text-uppercase mb-0">{customerTypePath.title} | {titleInfo}</h3>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-8 border-right">
                        <form className="form-horizontal" onSubmit={e => onSubmit(e)}>
                            <div className="form-group row">
                                <Label htmlFor="type-name" isCol={ true } text="Tipe" isMandatory={ true } value={ customerType.name } />
                                <div className="col-md-9">
                                    <input 
                                        id="type-name"
                                        type="text" 
                                        className="form-control" 
                                        name="name"
                                        value={customerType.name}
                                        onChange={ e => onInputChange(e) } 
                                    />
                                </div>
                            </div>

                            <div className="form-group row">
                                <Label isCol={ true } text="Status" />
                                <div className="col-md-9">
                                    <div className="custom-control custom-checkbox">
                                        <input 
                                            id="customer-type-is-active"
                                            type="checkbox" 
                                            className="custom-control-input" 
                                            name="isActive"
                                            value={ customerType.isActive }
                                            checked={ customerType.isActive }
                                            onChange={ e => onActiveChange(e) } 
                                        />   
                                        <label htmlFor="customer-type-is-active" className="custom-control-label">Aktif</label>
                                    </div>
                                </div>
                            </div>

                            <div className="form-group row">
                                <Label isCol={ true } />
                                <div className="col-md-9">
                                    <ActionButton 
                                        isSave={ true }
                                        isDisabledSave={ isDisabledSave } 
                                        isReset={ isResetable } 
                                        onReset={ onReset }/>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div className="col-md-4">
                        <Note isAction={ true } />
                    </div>
                </div>
                    
            </div>
        </React.Fragment>
    );
};

export default Action;
